import _defineProperty from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var VOLUME_SWEEP_IMAGE_BASE = "/assets/images/scan_assist/volume_sweep";
/** Use until zone-specific images are added (e.g. left_lateral_transverse.svg) */
var FALLBACK_IMAGE = "".concat(VOLUME_SWEEP_IMAGE_BASE, "/Right Lateral Transverse.svg");
/**
 * Volume Sweep step content by zone and phase.
 * Add images under public/assets/images/volume_sweep/ as you add zones (e.g. left_lateral_transverse.svg).
 */
export function getVolumeSweepStepContent(t) {
  return {
    A: {
      transverse: {
        label: t("right_lateral", "Right Lateral"),
        imageSrc: "".concat(VOLUME_SWEEP_IMAGE_BASE, "/Right Lateral Sagittal.svg"),
        instructionLine1: t("slide_across_the_area_longitudinal", "Slide across the area"),
        instructionLine2: t("with_probe_in_longitudinal", "with the probe in longitudinal..."),
        secondaryInstruction: t("capture_slide_and_2_fans", "Capture slide and 2 Fans")
      },
      longitudinal: {
        label: t("right_lateral", "Right Lateral"),
        imageSrc: "".concat(VOLUME_SWEEP_IMAGE_BASE, "/Right Lateral Transverse.svg"),
        instructionLine1: t("sweep_across_the_area", "Sweep across the area"),
        instructionLine2: t("with_probe_in_transverse", "with the probe in transverse..."),
        secondaryInstruction: t("capture_sweep_and_2_fans", "Capture sweep and 2 Fans")
      }
    },
    B: {
      transverse: {
        label: t("right_anterior", "Right Anterior"),
        imageSrc: "".concat(VOLUME_SWEEP_IMAGE_BASE, "/Right Anterior Sagittal.svg"),
        instructionLine1: t("sweep_across_the_area_longitudinal", "Sweep across the area"),
        instructionLine2: t("with_probe_in_longitudinal", "with the probe in longitudinal..."),
        secondaryInstruction: t("capture_slide_and_3_fans", "Capture slide and 3 Fans")
      },
      longitudinal: {
        label: t("right_anterior", "Right Anterior"),
        imageSrc: "".concat(VOLUME_SWEEP_IMAGE_BASE, "/Right Anterior Transverse.svg"),
        instructionLine1: t("sweep_across_the_area", "Sweep across the area"),
        instructionLine2: t("with_probe_in_transverse", "with the probe in transverse..."),
        secondaryInstruction: t("capture_sweep_and_3_fans", "Capture sweep and 3 Fans")
      }
    },
    C: {
      transverse: {
        label: t("left_anterior", "Left Anterior"),
        imageSrc: "".concat(VOLUME_SWEEP_IMAGE_BASE, "/Left Anterior Sagittal.svg"),
        instructionLine1: t("sweep_across_the_area_longitudinal", "Sweep across the area"),
        instructionLine2: t("with_probe_in_longitudinal", "with the probe in longitudinal..."),
        secondaryInstruction: t("capture_slide_and_3_fans", "Capture slide and 3 Fans")
      },
      longitudinal: {
        label: t("left_anterior", "Left Anterior"),
        imageSrc: "".concat(VOLUME_SWEEP_IMAGE_BASE, "/Left Anterior Transverse.svg"),
        instructionLine1: t("sweep_across_the_area", "Sweep across the area"),
        instructionLine2: t("with_probe_in_transverse", "with the probe in transverse..."),
        secondaryInstruction: t("capture_sweep_and_3_fans", "Capture sweep and 3 Fans")
      }
    },
    D: {
      transverse: {
        label: t("left_lateral", "Left Lateral"),
        imageSrc: "".concat(VOLUME_SWEEP_IMAGE_BASE, "/Left Lateral Sagittal.svg"),
        instructionLine1: t("slide_across_the_area_longitudinal", "Slide across the area"),
        instructionLine2: t("with_probe_in_longitudinal", "with the probe in longitudinal..."),
        secondaryInstruction: t("capture_slide_and_2_fans", "Capture slide and 2 Fans")
      },
      longitudinal: {
        label: t("left_lateral", "Left Lateral"),
        imageSrc: "".concat(VOLUME_SWEEP_IMAGE_BASE, "/Left Lateral Transverse.svg"),
        instructionLine1: t("sweep_across_the_area", "Sweep across the area"),
        instructionLine2: t("with_probe_in_transverse", "with the probe in transverse..."),
        secondaryInstruction: t("capture_sweep_and_2_fans", "Capture sweep and 2 Fans")
      }
    },
    E: {
      transverse: {
        label: t("left_posterior", "Left Posterior"),
        imageSrc: "".concat(VOLUME_SWEEP_IMAGE_BASE, "/Left Posterior Sagittal.svg"),
        instructionLine1: t("sweep_across_the_area_longitudinal", "Sweep across the area"),
        instructionLine2: t("with_probe_in_longitudinal", "with the probe in longitudinal..."),
        secondaryInstruction: t("capture_slide_and_3_fans", "Capture slide and 3 Fans")
      },
      longitudinal: {
        label: t("left_posterior", "Left Posterior"),
        imageSrc: "".concat(VOLUME_SWEEP_IMAGE_BASE, "/Left Posterior Transverse.svg"),
        instructionLine1: t("sweep_across_the_area", "Sweep across the area"),
        instructionLine2: t("with_probe_in_transverse", "with the probe in transverse..."),
        secondaryInstruction: t("capture_sweep_and_3_fans", "Capture sweep and 3 Fans")
      }
    },
    F: {
      transverse: {
        label: t("right_posterior", "Right Posterior"),
        imageSrc: "".concat(VOLUME_SWEEP_IMAGE_BASE, "/Right Posterior Sagittal.svg"),
        instructionLine1: t("sweep_across_the_area_longitudinal", "Sweep across the area"),
        instructionLine2: t("with_probe_in_longitudinal", "with the probe in longitudinal..."),
        secondaryInstruction: t("capture_slide_and_3_fans", "Capture slide and 3 Fans")
      },
      longitudinal: {
        label: t("right_posterior", "Right Posterior"),
        imageSrc: "".concat(VOLUME_SWEEP_IMAGE_BASE, "/Right Posterior Transverse.svg"),
        instructionLine1: t("sweep_across_the_area", "Sweep across the area"),
        instructionLine2: t("with_probe_in_transverse", "with the probe in transverse..."),
        secondaryInstruction: t("capture_sweep_and_3_fans", "Capture sweep and 3 Fans")
      }
    }
  };
}

/** Slide progress per zone: 4 (2-2) or 6 (3-3). Override per zone as needed. */
var VOLUME_SWEEP_SLIDES = {
  A: 4,
  B: 4,
  C: 6,
  D: 6,
  E: 6,
  F: 6
};
function slidesConfigFromTotal(total) {
  var half = Math.floor(total / 2);
  return {
    total: total,
    filledByPhase: {
      transverse: 0,
      longitudinal: half,
      submit: total
    }
  };
}
export function getVolumeSweepSlidesConfig(zone) {
  var _VOLUME_SWEEP_SLIDES$;
  return slidesConfigFromTotal((_VOLUME_SWEEP_SLIDES$ = VOLUME_SWEEP_SLIDES[zone]) !== null && _VOLUME_SWEEP_SLIDES$ !== void 0 ? _VOLUME_SWEEP_SLIDES$ : 4);
}

/**
 * Get step content for a zone and phase. Uses longitudinal content for "submit" phase.
 */
export function getVolumeSweepContentForZonePhase(zone, phase, t) {
  var contentMap = getVolumeSweepStepContent(t);
  var zoneContent = contentMap[zone];
  var effectivePhase = phase === "submit" ? "longitudinal" : phase;
  var content = zoneContent[effectivePhase];
  return _objectSpread(_objectSpread({}, content), {}, {
    imageSrc: content.imageSrc || FALLBACK_IMAGE
  });
}